import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { EXPORT_APIS } from '../../constants/endPointsURLs';
import { EXPORT_CREATION_SOURCE } from '../../constants/exportCreationSource';
import Toggle from 'react-toggle';
import axios from 'axios';
import Carousel from '../common/Carousel/Carousel';
import SwipeRevealListItem from './SwipeRevealListItem';
import config from '../../dashboard_config.json';
import { isExistUser } from '../../utils/codecHandlers';
import './Export.css';

const common_export_icon = './images/common_export_icon.svg';
const facebookIcon = './images/facebook_icon.svg';
const youtubeIcon = './images/youtube_icon.svg';
const omniPlayerIcon = './images/omni_player_icon.svg';
const twitchIcon = './images/twitch_icon.svg';
const telegramIcon = './images/telegram_icon.svg';
const instagramIcon = './images/instagram_icon.svg';
const kickIcon = './images/kick_icon.svg';
const dacastIcon = './images/dacast_icon.svg';
const srtLogo = './images/srt_logo.svg';

// const SOURCES = ['video', 'recipent'];

const {
  showAmsExportsAndUseLogic,
  keepAmsExports,
  useAmsExportConvertAndLogic,
  enableOmniSrtH265Mode,
  amsPlayerPlayOrderProtocolType
} = config.dashboard.exports.amsExportsControl;

export const EXPORT_METHODS = [
  showAmsExportsAndUseLogic
    ? {
      id: 'OmnistreamLivePlayerRTMP',
      name: 'Omni Player RTMP',
      isCreated: true,
      type: 7,
      fields: [
        { id: 'url', name: 'Server URL', disabled: true, required: false, placeholder: 'rtmp://example.com/live' },
        { id: 'key', name: 'Stream Key', disabled: true, required: false, placeholder: 'Enter stream key' },
      ],
    } : null,
  {
    id: 'RTMP',
    name: 'Custom RTMP/S',
    isCreated: true,
    type: 0,
    fields: [
      { id: 'url', name: 'Server URL', required: true, placeholder: 'rtmp://... or rtmps://...' },
      { id: 'key', name: 'Stream Key', required: false, placeholder: 'Enter stream key' },
    ],
  },
  showAmsExportsAndUseLogic
    ? {
      id: 'OmnistreamLivePlayerSRT',
      name: 'Omni Player SRT',
      isCreated: true,
      type: 8,
      fields: [
        { id: 'host', name: 'Stream host', disabled: true, required: false, placeholder: 'Generated automatically' },
        { id: 'port', name: 'Port', disabled: true, required: false, placeholder: '9000' },
        {
          id: 'exportStreamId',
          name: 'Stream ID',
          disabled: true,
          required: false,
          placeholder: 'Enter stream ID',
        },
      ],
    } : null,
  {
    id: 'SRTListener',
    name: 'SRT Listener',
    isCreated: true,
    type: 2,
    fields: [
      { id: 'host', name: 'Stream host', disabled: true, required: false, placeholder: 'Generated automatically' },
      { id: 'port', name: 'Port', disabled: true, required: false, placeholder: 'Generated automatically' },
      { id: 'key', name: 'Passphrase', disabled: true, required: false, placeholder: 'Generated automatically' },
    ],
  },
  {
    id: 'SRTCaller',
    name: 'SRT Caller',
    isCreated: true,
    type: 1,
    fields: [
      { id: 'host', name: 'Stream host', disabled: false, required: true, placeholder: 'srt.example.com or 203.0.113.10' },
      { id: 'port', name: 'Port', disabled: false, required: true, placeholder: '9000' },
      {
        id: 'exportStreamId',
        name: 'Stream ID',
        disabled: false,
        required: false,
        placeholder: 'Enter stream ID',
      },
      { id: 'key', name: 'Passphrase', disabled: false, required: false, placeholder: 'Enter passphrase' },
    ],
  },
  {
    id: 'Facebook',
    name: 'Facebook Live',
    isCreated: false,
    fields: [
      { id: 'url', name: 'Streaming URL', required: true, placeholder: 'rtmp://example.com/live' },
      { id: 'key', name: 'Streaming Key', required: false, placeholder: 'Enter stream key' },
    ],
  },
  {
    id: 'Youtube',
    name: 'YouTube Live',
    isCreated: false,
    fields: [
      { id: 'url', name: 'Streaming URL', required: true, placeholder: 'rtmp://example.com/live' },
      { id: 'key', name: 'Streaming Key', required: false, placeholder: 'Enter stream key' },
    ],
  },
  {
    id: 'Twitch',
    name: 'Twitch Live',
    isCreated: false,
    fields: [
      { id: 'url', name: 'Streaming URL', required: true, placeholder: 'rtmp://example.com/live' },
      { id: 'key', name: 'Streaming Key', required: false, placeholder: 'Enter stream key' },
    ],
  },
  {
    id: 'Telegram',
    name: 'Telegram',
    isCreated: true,
    type: 10,
    fields: [
      { id: 'url', name: 'Server URL', required: true, placeholder: 'rtmps://dcX-1.rtmp.t.me/s/' },
      { id: 'key', name: 'Stream Key', required: true, placeholder: 'Enter stream key' },
    ],
  },
  {
    id: 'Instagram',
    name: 'Instagram',
    isCreated: true,
    type: 11,
    fields: [
      { id: 'url', name: 'Server URL', required: true, placeholder: 'rtmp://... or rtmps://...' },
      { id: 'key', name: 'Stream Key', required: true, placeholder: 'Enter stream key' },
    ],
  },
  {
    id: 'Kick',
    name: 'Kick Live',
    isCreated: false,
    fields: [
      { id: 'url', name: 'Streaming URL', required: true, placeholder: 'rtmp://example.com/live' },
      { id: 'key', name: 'Streaming Key', required: false, placeholder: 'Enter stream key' },
    ],
  },
  {
    id: 'DacastRTMP',
    name: 'Dacast RTMP',
    isCreated: true,
    type: 13,
    fields: [
      { id: 'url', name: 'Server URL', required: true, placeholder: 'rtmp://... or rtmps://rtmp.live.dacast.com/live' },
      { id: 'key', name: 'Stream Key', required: true, placeholder: 'Enter stream key' },
    ],
  },
  {
    id: 'DacastSRT',
    name: 'Dacast SRT',
    isCreated: true,
    type: 14,
    fields: [
      { id: 'url', name: 'SRT URL', required: true, placeholder: 'srt://srt.live.dacast.com:7777/?streamid=your_stream_id' },
    ],
  },
].filter(Boolean);

class Export extends React.Component {
  state = {
    showOptions: false,
    currentOption: 'RTMP',
    currentSource: '',
    currentDisabled: false,
    exportList: [],
    formFields: {},
    focusedPrimaryId: '',
    exportLabels: null,
    isOpenLabel: { id: null, isOpen: false, value: '', isOpenEdit: false },
    showEditModal: false,
    isShowText: false,
    enableOmniSrtH265Mode: enableOmniSrtH265Mode, // enable or disable SRT_AMS mode (change settings: bitrate, 2Mb/s and codec, H.265)
    isEnabledDeleteAll: true,
    activeCategory: 'all',
    activeCreatedCategory: 'all',
    exportViewMode: (() => {
      try {
        return localStorage.getItem('export_methods_view_mode') || 'grid';
      } catch (err) {
        return 'grid';
      }
    })(),
    createdExportViewMode: (() => {
      try {
        return localStorage.getItem('created_exports_view_mode') || 'list';
      } catch (err) {
        return 'list';
      }
    })(),
    customOrder: (() => {
      try {
        return JSON.parse(localStorage.getItem('export_methods_custom_order') || 'null');
      } catch (err) {
        return null;
      }
    })(),
    draggedId: null,
    dragOverId: null,
    openSwipeItemId: null,
  };

  setExportViewMode = (mode) => {
    try {
      localStorage.setItem('export_methods_view_mode', mode);
    } catch (err) {}
    this.setState({ exportViewMode: mode });
  };

  setCreatedExportViewMode = (mode) => {
    try {
      localStorage.setItem('created_exports_view_mode', mode);
    } catch (err) {}
    this.setState({ createdExportViewMode: mode });
  };

  componentDidMount(prevProps, prevState) {
    this.fetchItems(false, this.props.focusedPrimaryId);
    this.props.setFetchExportListFn(this.fetchItems);
  }

  setNewBroadcastSettings = (
    omniExportSRT,
    broadcastSettings,
    notificationText,
    type
  ) => {
    const generateMessage = (codec, bitrate, text) => {
      return `${text}, Codec was changed to ${codec} and Bitrate was change to ${bitrate}Mb/s`;
    };
    const { isExist, isEnabled, isEnabledAnyAnotherExport } = omniExportSRT;
    const isPrimaryConnected =
      Object.keys(broadcastSettings).length === 0 ? false : true;
    if (isPrimaryConnected) {
      if (type === 'delete' && isExist) {
        broadcastSettings.codec = 'H.264';
        broadcastSettings.maxBitrate = '5';
        this.props.showNotification(
          'export',
          generateMessage(
            broadcastSettings.codec,
            broadcastSettings.maxBitrate,
            notificationText
          )
        );
      } else if (type === 'delete-all') {
        if (isEnabledAnyAnotherExport) {
          this.props.showNotification('export', notificationText);
        } else {
          broadcastSettings.codec = 'H.264';
          broadcastSettings.maxBitrate = '5';
          this.props.showNotification(
            'export',
            generateMessage(
              broadcastSettings.codec,
              broadcastSettings.maxBitrate,
              notificationText
            )
          );
        }
      } else {
        if (isExist) {
          if (isEnabled) {
            if (isEnabledAnyAnotherExport) {
              broadcastSettings.codec = 'H.264';
              broadcastSettings.maxBitrate = '5';
              this.props.showNotification(
                'export',
                generateMessage(
                  broadcastSettings.codec,
                  broadcastSettings.maxBitrate,
                  notificationText
                )
              );
            } else {
              broadcastSettings.codec = 'H.265';
              broadcastSettings.maxBitrate = '2';
              this.props.showNotification(
                'export',
                generateMessage(
                  broadcastSettings.codec,
                  broadcastSettings.maxBitrate,
                  notificationText
                )
              );
            }
          } else {
            broadcastSettings.codec = 'H.264';
            broadcastSettings.maxBitrate = '5';
            this.props.showNotification(
              'export',
              generateMessage(
                broadcastSettings.codec,
                broadcastSettings.maxBitrate,
                notificationText
              )
            );
          }
        } else {
          this.props.showNotification('export', notificationText);
        }
      }
    }
    return broadcastSettings;
  };

  checkIsExistOmniSRT = (exportList, notificationText, type) => {
    if (this.state.enableOmniSrtH265Mode) {
      const broadcastSettings = { ...this.props.broadcastSettings };
      const { camera, streamType } = broadcastSettings;
      if (
        camera !== 'external' &&
        streamType !== 'record' &&
        streamType !== 'record-and-play' &&
        !this.props.isPrimaryBroadcasting
      ) {
        const exportSRT =
          exportList === 'state'
            ? this.state.exportList.find((exp) => exp.type === 8)
            : Array.isArray(exportList)
              ? exportList.find((exp) => exp.type === 8)
              : exportList;
        const isEnabled = exportSRT && exportSRT.isEnabled;
        const isExistAnyAnotherExport = this.state.exportList.filter(
          (exp) => exp.type !== 8
        );
        const isEnabledAnyAnotherExport = !!(
          isExistAnyAnotherExport.length !== 0 &&
          isExistAnyAnotherExport.filter((exp) => exp.isEnabled === true).length
        );
        const omniExportSRT = {
          isExist: Array.isArray(exportSRT) ? !!exportSRT.length : !!exportSRT,
          isEnabled,
          isEnabledAnyAnotherExport,
        };
        const newBroadcastSettings = this.setNewBroadcastSettings(
          omniExportSRT,
          broadcastSettings,
          notificationText,
          type
        );
        this.props.clickSettingsApply(newBroadcastSettings);
      } else {
        this.props.showNotification('export', notificationText);
      }
    } else {
      this.props.showNotification('export', notificationText);
    }
  };

  checkBroadcastSettings = (settings) => {
    const settingsLength = Object.keys(settings).length;
    if (settingsLength !== 0) {
      this.handleUpdateAmsSrt();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.focusedPrimaryId !== this.props.focusedPrimaryId) {
      this.fetchItems(false, this.props.focusedPrimaryId);
    }

    if (this.props.isExportDisplay !== prevProps.isExportDisplay) {
      this.fetchItems(this.state.showOptions, this.state.focusedPrimaryId);
      this.setState({
        isOpenLabel: {
          ...this.state.isOpenLabel,
          isOpen: false,
          isOpenEdit: false,
        },
      });
    }

    this.setIsEnabledDeleteAll(prevState);

    // Check if we have exports that are not equal to type 8 and 7

    if (this.state.exportList.length !== 0 && !this.props.isExistExport) {
      this.props.setIsExistExport(true);
    }
    if (this.state.exportList.length === 0 && this.props.isExistExport) {
      this.props.setIsExistExport(false);
    }
  }

  setShowEditModal = (showEditModal) => {
    this.setState({ showEditModal: showEditModal });
  };

  setIsEnabledDeleteAll = (prevState) => {
    if (
      this.state.exportList.length !== 0 &&
      this.state.exportList !== prevState.exportList
    ) {
      if (keepAmsExports && (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni)) {
        const isExistOtherExportsTypes = this.state.exportList.filter(
          (item) => item.type !== 8 && item.type !== 7
        );
        if (
          isExistOtherExportsTypes.length !== 0 &&
          !this.state.isEnabledDeleteAll
        ) {
          this.setState({ ...this.state, isEnabledDeleteAll: true });
        } else if (
          isExistOtherExportsTypes.length === 0 &&
          this.state.isEnabledDeleteAll
        ) {
          return this.setState({ ...this.state, isEnabledDeleteAll: false });
        }
      } else if (!this.state.isEnabledDeleteAll) {
        return this.setState({ ...this.state, isEnabledDeleteAll: true });
      }
    }
  };

  checkIExistAnyExport = (data) => {
    if (
      data &&
      data.length === 0 &&
      useAmsExportConvertAndLogic &&
      (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni)
    ) {
      return this.handleCreateExport();
    }
    return;
  };

  generateAMSExport = async (config) => {
    try {
      const data = {
        exportStreamId: '',
        isEnabled: true,
        protocol: config.protocol,
        src: 0,
        type: config.type,
        exportCreationSource: this.props.isController
          ? EXPORT_CREATION_SOURCE.CONTROLLER
          : EXPORT_CREATION_SOURCE.DASHBOARD,
      };

      const response = await axios({
        method: 'post',
        url: config.url,
        withCredentials: true,
        data,
      });

      if (response.status === 200) {
        // If we create export type 7 or 8 then we should update codec type to H.264
        this.props.handleUpdateCodecType('H.264');
      }
      if (config.type === 8) {
        this.fetchItems(false, this.state.focusedPrimaryId);
      }
    } catch (e) {
      console.log(e);
    }
  };

  getAMSExportInfo = async (focusedPrimaryId) => {
    try {
      const response = await axios({
        method: 'get',
        url: EXPORT_APIS.getAMSExport(focusedPrimaryId),
        withCredentials: true,
      });

      return response.data;
    } catch (e) {
      console.log(e);
    }
  };

  checkIsEnabledExports = async (data, focusedPrimaryId) => {
    const isAnyExportsExist = data.filter(
      (exp) => exp.type !== 8 && exp.type !== 7
    );
    if (isAnyExportsExist.length !== 0) {
      const isRTMPEnabled = data
        .filter(
          (exp) =>
            (exp.protocol === 'rtmp' || exp.protocol === 'rtmps') &&
            exp.type !== 7
        )
        .filter((exp) => exp.isEnabled === true);

      if (isRTMPEnabled.length === 0) {
        const amsExport = await this.getAMSExportInfo(focusedPrimaryId);
        if (amsExport.amsExportProtocol !== 'SRT') {
          this.generateAMSExport({
            url: EXPORT_APIS.generateExportSRT(focusedPrimaryId),
            type: 8,
            protocol: 'srt',
          });
        }
      }
    } else if (data.length !== 0 && data[0].type !== 8) {
      this.generateAMSExport({
        url: EXPORT_APIS.generateExportSRT(focusedPrimaryId),
        type: 8,
        protocol: 'srt',
      });
    }
  };

  checkIsRTMPExport = () => {
    const isRTMPExist = this.state.exportList
      .filter(
        (exp) =>
          (exp.protocol === 'rtmp' || exp.protocol === 'rtmps') &&
          exp.type !== 7
      )
      .filter((exp) => exp.isEnabled === true);

    return isRTMPExist.length > 0;
  };

  //-----------------------------API functions------------------------------------------------------------------------

  fetchItems = async (show, focusedPrimaryId) => {
    if (!focusedPrimaryId) return;
    // this.setState({ exportList: [],
    try {
      const res = await axios({
        method: 'get',
        url: EXPORT_APIS.getExportList(focusedPrimaryId),
        withCredentials: true,
      });
      const data = res.data['exports'];
      if (show) {
        this.setState({
          focusedPrimaryId: focusedPrimaryId,
          currentDisabled: true,
          exportList: data,
          showOptions: true,
          showEditModal: false,
        });
      } else {
        this.setState({
          focusedPrimaryId: focusedPrimaryId,
          formFields: {},
          currentDisabled: false,
          exportList: data,
          showOptions: data.length === 0,
          showEditModal: false,
        });
      }
      this.getExportLabel(focusedPrimaryId);
      if (keepAmsExports && (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni)) {
        this.checkIExistAnyExport(data);
      }
      if (useAmsExportConvertAndLogic && (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni)) {
        this.checkBroadcastSettings(this.props.broadcastSettings);
        this.checkIsEnabledExports(data, focusedPrimaryId);
      }
    } catch (error) {
      console.log(error);
    }
  };

  showExports = async (focusedPrimaryId) => {
    try {
      const res = await axios({
        method: 'get',
        url: EXPORT_APIS.getExportList(focusedPrimaryId),
        withCredentials: true,
      });
      let data = res.data['exports'];
      this.setState({
        focusedPrimaryId: focusedPrimaryId,
        formFields: {},
        currentDisabled: false,
        exportList: data,
        showOptions: data.length === 0,
        showEditModal: false,
      });
      if (data.length === 0) {
        this.props.showNotification(
          'show',
          `No exports found for ${this.props.primaryName}`
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  getExportLabel = async (focusedPrimaryId) => {
    try {
      const res = await axios({
        method: 'get',
        url: EXPORT_APIS.getExportLabels(focusedPrimaryId),
        withCredentials: true,
      });
      this.setState({
        exportLabels: res.data.exports,
        isOpenLabel: {
          ...this.state.isOpenLabel,
          isOpenEdit: false,
          value: '',
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  setExportLabel = async (focusedPrimaryId, exportsItemId, labelText) => {
    try {
      const data = JSON.stringify({
        exportLabel: labelText,
      });
      const response = await axios({
        method: 'post',
        url: EXPORT_APIS.setExportLabel(focusedPrimaryId, exportsItemId),
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        data: data,
      });
      if (response.status === 200 || response.status === 201) {
        this.getExportLabel(focusedPrimaryId);
      } else {
        this.props.showNotification('error', 'Server error');
      }
    } catch (error) {
      this.props.showNotification('error', 'Server error');
    }
  };

  deleteExportLabel = async (focusedPrimaryId, exportsItemId) => {
    try {
      await axios({
        method: 'delete',
        url: EXPORT_APIS.deleteExportLabel(focusedPrimaryId, exportsItemId),
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      this.getExportLabel(focusedPrimaryId);
      this.setState({
        isOpenLabel: {
          ...this.state.isOpenLabel,
          isOpen: false,
          isOpenEdit: false,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  handleCreateExport = async () => {
    try {
      const data = {
        exportStreamId: '',
        isEnabled: true,
        protocol: 'srt',
        src: 0,
        type: 8,
        exportCreationSource: this.props.isController
          ? EXPORT_CREATION_SOURCE.CONTROLLER
          : EXPORT_CREATION_SOURCE.DASHBOARD,
      };
      const res = await axios({
        method: 'post',
        url: EXPORT_APIS.generateExportSRT(this.state.focusedPrimaryId),
        withCredentials: true,
        data: data,
      });
      this.checkCodecType();
      this.fetchItems(true, this.state.focusedPrimaryId);
    } catch (error) {
      this.props.showNotification('export', error.response.data.message);
    }
  };

  checkCodecType = () => {
    const broadcastSettings = { ...this.props.broadcastSettings };
    if (broadcastSettings.codec === 'H.264') {
      broadcastSettings.codec = 'H.265';
      this.props.clickSettingsApply(broadcastSettings);
    }
  };

  handleUpdateCodecType = (type) => {
    const broadcastSettings = { ...this.props.broadcastSettings };
    if (
      Object.keys(broadcastSettings).length !== 0 &&
      broadcastSettings.codec !== type
    ) {
      broadcastSettings.codec = type;
      this.props.clickSettingsApply(broadcastSettings);
    }
  };

  handleUpdateAmsSrt = () => {
    const { exportList } = this.state;
    if (exportList.length !== 0) {
      const isExistOmniSRT = exportList.find((exp) => exp.type === 8);
      const isEnabledAnyAnotherExport = exportList.find(
        (exp) => exp.type !== 8 && exp.isEnabled
      );
      const isChangedCodecManually = isExistUser(this.state.focusedPrimaryId);
      if (!isChangedCodecManually) {
        if (!!isExistOmniSRT && !isEnabledAnyAnotherExport) {
          this.handleUpdateCodecType('H.265');
        } else {
          this.handleUpdateCodecType('H.264');
        }
      }
    }
  };

  //------------------------------------------------------------------------------------------------------------------

  handleClick = () => {
    this.setState({
      showOptions: !this.state.showOptions,
      formFields: {},
      currentOption: '',
      currentSource: '',
    });
  };

  handleChoice = (id) => {
    this.setState({
      currentOption: id,
      currentDisabled: false,
      formFields: {},
    });
  };

  handleInputChange = (e) => {
    let value = e.target.value;
    let formFields = { ...this.state.formFields };
    formFields[e.target.id] = value;
    this.setState({ formFields });
  };

  handleRefreshExport = (focusedPrimaryId) => {
    this.fetchItems(false, focusedPrimaryId);
    this.setState({
      isOpenLabel: {
        ...this.state.isOpenLabel,
        isOpen: false,
        value: '',
        isOpenEdit: false,
      },
    });
  };

  handleBuildUrl = (item) => {
    let url = `${item.protocol}://`;
    switch (item.type) {
      case 0:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
        url += item.host;
        if (item.port) {
          url += `:${item.port}`;
        }
        if (!item.endpoint) {
          url += `/${item.key}`;
        }
        if (item.endpoint) {
          url += `/${item.endpoint}/${item.key}`;
        }
        break;
      case 1:
      case 14:
        url += `${item.host}:${item.port}`;
        let hasQueryParam = false;

        if (item.key) {
          url += `?pbkeylen=32&passphrase=${item.key}`;
          hasQueryParam = true;
        }

        if (item.exportStreamId) {
          url += hasQueryParam ? '&' : '?';
          url += `streamid=${item.exportStreamId}`;
          hasQueryParam = true;
        }

        url += hasQueryParam ? '&' : '?';

        if (item.type === 14) {
          url += 'mode=caller';
        } else {
          url += 'pkt_size=1000&mode=caller';
        }
        break;
      case 2:
        url += `${item.host}:${item.port}?`;
        if (item.key) {
          url += `pbkeylen=32&passphrase=${item.key}&`;
        }
        url += 'pkt_size=1000&mode=listener';
        break;
      case 8:
        url += `${item.host}:${item.port}?streamid=${item.exportStreamId}&pkt_size=1000&mode=caller`;
        break;
      default:
        url = '';
    }
    return url;
  };

  onUrlClick = (item) => {
    const exportType = this.defineExportType(item.type);
    const exportName = exportType.name;
    const url = this.handleBuildUrl(item);
    navigator.clipboard.writeText(url);
    this.props.showNotification(
      'url_clipboard',
      exportName + ' URL copied to clipboard'
    );
  };

  handleCopyField = (value, name) => {
    navigator.clipboard.writeText(value ? value : null);
    this.props.showNotification(
      'value_clipboard',
      `${name} copied to clipboard`
    );
  };

  handleCopyEmdedCode = (event) => {
    let playerSRC = '';
    const exportsItemId = parseInt(event.currentTarget.value);
    const item = this.state.exportList.find(
      (elem) => elem.id === exportsItemId
    );

    playerSRC = `${item.player}&playOrder=hls`;

    const playingProtocol =
      item.playingProtocols &&
      item.playingProtocols.find(
        (protocol) =>
          protocol.type ===
          amsPlayerPlayOrderProtocolType
      );

    if (playingProtocol) {
      playerSRC = playingProtocol.playerURL;
    }

    const iframeCode = `<iframe width="560" height="315" src="${playerSRC}" frameborder="0" allowfullscreen></iframe>`;
    navigator.clipboard.writeText(iframeCode);
    this.props.showNotification(
      'value_clipboard',
      'iFrame code successfully copied to the clipboard'
    );
  };

  handleDelete = async (exportsItemId, isChange) => {
    if (isNaN(exportsItemId)) {
      return;
    }
    const currentExport = this.state.exportList.find(
      (exp) => exp.id === exportsItemId
    );
    try {
      await axios({
        method: 'delete',
        url: EXPORT_APIS.deleteExport(
          this.state.focusedPrimaryId,
          exportsItemId
        ),
        withCredentials: true,
      });
      if (currentExport && currentExport.type === 8) {
        const notificationText = `Omni Player SRT - Export was deleted successfully`;
        this.checkIsExistOmniSRT(currentExport, notificationText, 'delete');
      } else if (!isChange) {
        const exportType = currentExport ? this.defineExportType(currentExport.type, currentExport) : null;
        const exportName = exportType ? exportType.name : 'Export';
        this.props.showNotification(
          'export',
          `${exportName} export has been deleted successfully`
        );
      }
    } catch (error) {
      console.log(error.response);
      this.props.showNotification(
        'cannot_delete',
        error.response ? error.response.data.message : 'Server error'
      );
    }
    if (!isChange) {
      this.fetchItems(false, this.state.focusedPrimaryId);
    }
  };

  handleToggle = async (event) => {
    const exportsItemId = parseInt(event.target.value);
    if (isNaN(exportsItemId)) {
      return;
    }
    const exportItem = this.state.exportList.find(
      (item) => item.id === exportsItemId
    );
    exportItem.isEnabled = event.target.checked;

    try {
      const amsExport = await this.getAMSExportInfo(
        this.state.focusedPrimaryId
      );
      if (useAmsExportConvertAndLogic && (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni)) {
        if (
          (exportItem.protocol === 'rtmp' || exportItem.protocol === 'rtmps') &&
          exportItem.type !== 7 &&
          exportItem.isEnabled &&
          amsExport.amsExportProtocol !== 'RTMP'
        ) {
          await this.generateAMSExport({
            url: EXPORT_APIS.generateExportRTMP(this.state.focusedPrimaryId),
            type: 7,
            protocol: 'rtmp',
          });
        }
      }

      await axios({
        method: 'put',
        url: EXPORT_APIS.putExport(this.state.focusedPrimaryId, exportsItemId),
        withCredentials: true,
        data: exportItem,
      });
      if (exportItem.type === 8) {
        if (exportItem.isEnabled) {
          const notificationText = `Omni Player SRT - Export was enabled successfully`;
          this.checkIsExistOmniSRT(exportItem, notificationText);
        } else {
          const notificationText = `Omni Player SRT - Export was disabled successfully`;
          this.checkIsExistOmniSRT(exportItem, notificationText);
        }
      }
    } catch (error) {
      this.props.showNotification('cannot_enable', error.response.data.message);
    }
    this.fetchItems(false, this.state.focusedPrimaryId);
  };

  defineExportType = (type, item = null) => {
    let data = {
      id: '',
      name: '',
      subTitle: null,
      isEdit: undefined,
      exportCreationSource:
        item && item.exportCreationSource !== undefined
          ? item.exportCreationSource
          : null,
    };
    switch (type) {
      case 0:
        return {
          ...data,
          id: 'RTMP',
          name: 'Custom RTMP/S',
          isEdit: true,
          iconType: 'common',
        };
      case 1:
        return {
          ...data,
          id: 'SRTCaller',
          name: 'SRT Caller',
          isEdit: true,
          iconType: 'common',
        };
      case 2:
        return {
          ...data,
          id: 'SRTListener',
          name: 'SRT Listener',
          isEdit: true,
          iconType: 'common',
        };
      case 3: {
        const userName = item && (item.fbUserName || item.userName);
        return {
          ...data,
          id: 'Facebook',
          name: 'Facebook Live',
          subTitle: userName ? `Timeline: ${userName}` : null,
          isEdit: false,
          iconType: 'facebook',
        };
      }
      case 4: {
        const pageName = item && (item.fbPageName || item.pageName);
        return {
          ...data,
          id: 'Facebook',
          name: 'Facebook Live',
          subTitle: pageName ? `Page: ${pageName}` : null,
          isEdit: false,
          iconType: 'facebook',
        };
      }
      case 5: {
        const groupName = item && (item.fbGroupName || item.groupName);
        return {
          ...data,
          id: 'Facebook',
          name: 'Facebook Live',
          subTitle: groupName ? `Group: ${groupName}` : null,
          isEdit: false,
          iconType: 'facebook',
        };
      }
      case 6: {
        const ytChannel = item && (item.ytChannelName || item.channelName);
        return {
          ...data,
          id: 'Youtube',
          name: 'YouTube Live',
          subTitle: ytChannel ? `Channel: ${ytChannel}` : null,
          isEdit: false,
          iconType: 'youtube',
        };
      }
      case 7:
        return {
          ...data,
          id: 'OmnistreamLivePlayerRTMP',
          name: 'Omni Player RTMP',
          isEdit: true,
          iconType: 'omniPlayer',
        };
      case 8:
        return {
          ...data,
          id: 'OmnistreamLivePlayerSRT',
          name: 'Omni Player SRT',
          isEdit: true,
          iconType: 'omniPlayer',
        };
      case 9: {
        const twitchChannel = item && (item.twitchChannelName || item.channelName);
        return {
          ...data,
          id: 'Twitch',
          name: 'Twitch Live',
          subTitle: twitchChannel ? `Channel: ${twitchChannel}` : null,
          isEdit: false,
          iconType: 'Twitch',
        };
      }
      case 10:
        return {
          ...data,
          id: 'Telegram',
          name: 'Telegram',
          isEdit: true,
          iconType: 'Telegram',
        };
      case 11:
        return {
          ...data,
          id: 'Instagram',
          name: 'Instagram',
          isEdit: true,
          iconType: 'Instagram',
        };
      case 12: {
        const kickChannel = item && (item.kickChannelName || item.channelName);
        return {
          ...data,
          id: 'Kick',
          name: 'Kick Live',
          subTitle: kickChannel ? `Channel: ${kickChannel}` : null,
          isEdit: false,
          iconType: 'Kick',
        };
      }
      case 13:
        return {
          ...data,
          id: 'DacastRTMP',
          name: 'Dacast RTMP',
          isEdit: true,
          iconType: 'dacast',
        };
      case 14:
        return {
          ...data,
          id: 'DacastSRT',
          name: 'Dacast SRT',
          isEdit: true,
          iconType: 'dacast',
        };
      default:
        return {
          ...data,
          id: '',
          name: 'Type export not defined',
          isEdit: false,
          iconType: 'common',
        };
    }
  };

  handleCloseAnySwipe = () => {
    if (this.state.openSwipeItemId) {
      this.setState({ openSwipeItemId: null });
    }
  };

  handleShowModal = (event) => {
    const target = (event && (event.currentTarget || event.target)) || {};
    const exportsItemId = parseInt(target.value);
    const currentOption = (typeof target.getAttribute === 'function') ? target.getAttribute('name') : target.name;
    const item = this.state.exportList.find(
      (item) => item.id === exportsItemId
    );
    const exportType = item ? this.defineExportType(item.type, item) : (currentOption ? EXPORT_METHODS.find(m => m.id === currentOption) : null);
    const exportName = exportType ? exportType.name : '';
    const isEditExport = exportType ? exportType.isEdit : false;
    const buttonRole = {
      id: target.id,
      currentOption: currentOption,
    };

    if (buttonRole.id === 'copy') {
      const url = this.handleBuildUrl(item);

      const labelValue = url;
      this.handleChoice(buttonRole.currentOption);
      return this.props.setExportModalData(
        exportsItemId,
        this.handleDelete,
        this.handleHideModal,
        buttonRole,
        this.state.exportList,
        this.fetchItems,
        this.deleteLabelItem,
        this.setShowEditModal,
        exportName,
        labelValue,
        this.handleCopyField,
        true,
        undefined,
        this.checkIsExistOmniSRT
      );
    }

    if (buttonRole.id === 'delete-all-exports') {
      const labelValue = null;
      this.handleChoice(buttonRole.currentOption);
      return this.props.setExportModalData(
        exportsItemId,
        this.handleDelete,
        this.handleHideModal,
        buttonRole,
        this.state.exportList,
        this.fetchItems,
        this.deleteLabelItem,
        this.setShowEditModal,
        exportName,
        labelValue,
        this.handleCopyField,
        true,
        undefined,
        this.checkIsExistOmniSRT
      );
    }

    if (buttonRole.id === 'play_video' || buttonRole.id === 'share_video') {
      const labelValue = null;

      const item = this.state.exportList.find(
        (elem) => elem.id === exportsItemId
      );

      let videoUrl = `${item.player}&playOrder=hls`;

      const playingProtocol =
        item.playingProtocols &&
        item.playingProtocols.find(
          (protocol) =>
            protocol.type ===
            amsPlayerPlayOrderProtocolType
        );

      if (playingProtocol) {
        videoUrl = playingProtocol.playerURL;
      }

      this.handleChoice(buttonRole.currentOption);
      return this.props.setExportModalData(
        exportsItemId,
        this.handleDelete,
        this.handleHideModal,
        buttonRole,
        this.state.exportList,
        this.fetchItems,
        this.deleteLabelItem,
        this.setShowEditModal,
        exportName,
        labelValue,
        this.handleCopyField,
        true,
        videoUrl
      );
    }

    if (buttonRole.id === 'create-export') {
      const labelValue = null;
      this.handleChoice(buttonRole.currentOption);

      const isExistAmsExport = this.state.exportList.find(
        (exp) => exp.type === 7 || exp.type === 8
      );

      const isRTMPExist = this.checkIsRTMPExport();

      const exportType =
        isExistAmsExport && this.defineExportType(isExistAmsExport.type).id;

      if (exportType === currentOption) {
        return this.props.showNotification('export', 'Export already exists');
      } else if (
        !isRTMPExist &&
        currentOption === 'OmnistreamLivePlayerRTMP' &&
        useAmsExportConvertAndLogic &&
        (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni)
      ) {
        if (this.props.isUserFreeTrial) {
          return this.props.showNotification(
            'export',
            'Please enable RTMP export in order to use OMNI LIVE RTMP'
          );
        } else if (this.props.isUserBasic || this.props.isUserLiveOmni) {
          return this.props.showNotification(
            'export',
            'Your license type is not supporting switching Omni Live Player exports'
          );
        }
      }

      return this.props.setExportModalData(
        exportsItemId,
        this.handleDelete,
        this.handleHideModal,
        buttonRole,
        this.state.exportList,
        this.fetchItems,
        this.deleteLabelItem,
        this.setShowEditModal,
        exportName,
        labelValue,
        this.handleCopyField,
        true,
        undefined,
        this.checkIsExistOmniSRT,
        this.handleUpdateCodecType,
        this.props.isUserFreeTrial,
        this.props.isUserBasic,
        this.props.isUserLiveOmni,
        this.props.isUserGuest,
      );
    }
    if (isEditExport || buttonRole.id === 'delete-label') {
      const label =
        this.state.exportLabels !== null
          ? this.state.exportLabels.find((label) => label.id === exportsItemId)
          : null;
      const labelValue = label ? label['exportLabel'] : '';
      if (!item.isEnabled && buttonRole.id === 'edit') {
        return this.props.showNotification(
          'edit',
          'Cannot edit offline export, for edit please switch toggle on'
        );
      } else {
        return this.props.setExportModalData(
          exportsItemId,
          this.handleDelete,
          this.handleHideModal,
          buttonRole,
          this.state.exportList,
          this.fetchItems,
          this.deleteLabelItem,
          this.setShowEditModal,
          exportName,
          labelValue,
          this.handleCopyField,
          true,
          undefined,
          this.checkIsExistOmniSRT
        );
      }
    } else {
      if (buttonRole.id === 'edit') {
        return this.props.showNotification(
          'edit',
          `Update export type: ${exportName} is not allowed`
        );
      }
      if (buttonRole.id === 'delete') {
        return this.props.showNotification(
          'delete',
          `Delete export type: ${exportName} is not allowed`
        );
      }
    }
  };

  handleHideModal = (isEdit) => {
    this.props.setExportModalData(false);
    if (!isEdit) {
      this.setShowEditModal(false);
    }
  };

  //----------------------------------LABEL FUNCTIONS-------------------------------------------------------

  setOpenLabel = (id) => {
    if (
      this.state.isOpenLabel.id === id &&
      this.state.isOpenLabel.isOpenEdit === true
    ) {
      return;
    } else {
      if (
        this.state.isOpenLabel.id === id &&
        this.state.isOpenLabel.isOpen === true
      ) {
        this.setState({
          isOpenLabel: {
            ...this.state.isOpenLabel,
            id: id,
            isOpen: false,
            isOpenEdit: false,
          },
        });
      } else {
        this.setState({
          isOpenLabel: {
            ...this.state.isOpenLabel,
            id: id,
            isOpen: true,
            value: '',
            isOpenEdit: false,
          },
        });
      }
    }
  };

  saveLabelItem = (id) => {
    if (!this.state.isOpenLabel.value) {
      if (
        !this.state.isOpenLabel.isOpenEdit &&
        !this.state.isOpenLabel.isOpen
      ) {
        this.props.showNotification('save', 'You should press the edit button');
      } else {
        this.props.showNotification('save', 'Label could not be empty');
      }
    } else {
      this.setExportLabel(
        this.state.focusedPrimaryId,
        id,
        this.state.isOpenLabel.value
      );
    }
  };

  cancelLabelItem = () => {
    this.setState({
      isOpenLabel: {
        ...this.state.isOpenLabel,
        isOpen: false,
        value: '',
        isOpenEdit: false,
      },
    });
  };

  editLabelItem = (id) => {
    const exportLabels = this.state.exportLabels;
    const isExistLabel =
      exportLabels === null
        ? false
        : exportLabels.find((elem) => elem.id === id);
    const label = isExistLabel ? isExistLabel.exportLabel : false;
    if (label) {
      if (
        this.state.isOpenLabel.isOpenEdit &&
        this.state.isOpenLabel.id === id
      ) {
        return;
      } else {
        this.setState({
          isOpenLabel: {
            ...this.state.isOpenLabel,
            id: id,
            isOpenEdit: true,
            value: '',
          },
        });
      }
    } else {
      this.setState({
        isOpenLabel: {
          ...this.state.isOpenLabel,
          id: id,
          isOpenEdit: true,
          value: '',
        },
      });
    }
  };

  deleteLabelItem = (id) => {
    this.deleteExportLabel(
      this.state.focusedPrimaryId,
      id,
      this.state.isOpenLabel.value
    );
  };

  handleInputChangeLabel = (e) => {
    const value = e.target.value.slice(0, 30);
    this.setState({ isOpenLabel: { ...this.state.isOpenLabel, value: value } });
  };

  //------------------------------------------------------------------------------------------------

  handleShowText = () => {
    this.setState({ isShowText: !this.state.isShowText });
  };

  handleResetShowText = () => {
    this.setState({ isShowText: false });
  };

  renderLabelItem = (id) => {
    const exportLabels = this.state.exportLabels;
    const isOpenEdit =
      this.state.isOpenLabel.id === id
        ? this.state.isOpenLabel.isOpenEdit
        : false;
    const isExistLabel =
      exportLabels === null
        ? false
        : exportLabels.find((elem) => elem.id === id);
    const label = isExistLabel ? isExistLabel.exportLabel : false;
    const item = label
      ? isExistLabel
      : this.state.isOpenLabel.id === id
        ? this.state.isOpenLabel
        : null;

    return (
      <Fragment>
        {label ? (
          <div className="label-container">
            {isOpenEdit ? (
              <Fragment>
                <div className="input-group input-group-sm">
                  <input
                    id="displayed-label-name-input"
                    onChange={this.handleInputChangeLabel}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        this.saveLabelItem(item.id);
                      } else if (e.key === 'Escape') {
                        e.preventDefault();
                        this.cancelLabelItem(item.id);
                      }
                    }}
                    value={this.state.isOpenLabel.value}
                    className="form-control ml-0"
                    placeholder="Enter label..."
                    autoFocus
                    style={{
                      background: '#121212',
                      border: '1px solid #2a2a2a',
                      color: '#fff',
                      fontSize: '0.7rem',
                      height: '24px'
                    }}
                  />
                </div>
                <div className="label-buttons-container">
                  <button
                    className="export-label-btns material-icons"
                    id="label"
                    title="Save Label"
                    value={item.id.toString()}
                    onClick={() => this.saveLabelItem(item.id)}
                  >
                    check
                  </button>
                  <button
                    type="button"
                    className="export-label-btns material-icons"
                    id="label"
                    title="Cancel"
                    value={item.id.toString()}
                    onClick={() => this.cancelLabelItem(item.id)}
                  >
                    close
                  </button>
                </div>
              </Fragment>
            ) : (
              <div className="export-label-chip" title="Click to edit label">
                <i className="export-label-chip-icon material-icons">local_offer</i>
                <span
                  className="export-label-chip-text"
                  onClick={() => this.editLabelItem(item.id)}
                >
                  {label}
                </span>
                <button
                  type="button"
                  className="export-label-chip-remove material-icons"
                  id="delete-label"
                  value={item.id.toString()}
                  onClick={this.handleShowModal}
                  title="Remove label"
                >
                  close
                </button>
              </div>
            )}
          </div>
        ) : (
          item && item.isOpen && (
            <div className="label-container">
              <div className="input-group input-group-sm">
                <input
                  id="displayed-label-name-input"
                  onChange={this.handleInputChangeLabel}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      this.saveLabelItem(item.id);
                    } else if (e.key === 'Escape') {
                      e.preventDefault();
                      this.cancelLabelItem(item.id);
                    }
                  }}
                  value={this.state.isOpenLabel.value}
                  className="form-control ml-0"
                  placeholder="New label..."
                  autoFocus
                  style={{
                    background: '#121212',
                    border: '1px solid #2a2a2a',
                    color: '#fff',
                    fontSize: '0.7rem',
                    height: '24px'
                  }}
                />
              </div>
              <div className="label-buttons-container">
                <button
                  className="export-label-btns material-icons"
                  id="label"
                  title="Save Label"
                  value={item.id.toString()}
                  onClick={() => this.saveLabelItem(item.id)}
                >
                  check
                </button>
                <button
                  type="button"
                  className="export-label-btns material-icons"
                  id="label"
                  title="Cancel"
                  value={item.id.toString()}
                  onClick={() => this.cancelLabelItem(item.id)}
                >
                  close
                </button>
              </div>
            </div>
          )
        )}
      </Fragment>
    );
  };

  checkFieldKey = (id, formFields) => {
    if (id === 'key') {
      if (!formFields[id]) {
        return '';
      }
      if (this.state.isShowText) {
        return formFields[id]
          ? formFields[id].split('').length > 40
            ? formFields[id].slice(0, 40) + '...'
            : formFields[id]
          : '';
      } else {
        if (formFields[id]) {
          return formFields[id].split('').length > 10
            ? '••••••••••••••••••••••••••••••••••••••••'
            : formFields[id] || '';
        }
      }
    } else {
      return formFields[id] || '';
    }
  };

  renderExportIcon = (exportId, iconType) => {
    if (exportId === 'SRTCaller' || exportId === 'SRTListener' || iconType === 'srt') {
      return (
        <img
          alt="srt icon"
          src={srtLogo}
          className="export-option-icon-img"
          style={{ width: '22px', height: '22px', objectFit: 'contain', background: 'transparent' }}
        />
      );
    }
    if (exportId === 'RTMP') {
      return <i className="material-icons rtmp-icon">cloud_upload</i>;
    }
    if (exportId === 'OmnistreamLivePlayerRTMP' || exportId === 'OmnistreamLivePlayerSRT') {
      return <i className="material-icons omni-icon">live_tv</i>;
    }

    let imgSrc = common_export_icon;
    if (iconType === 'dacast' || (exportId && exportId.includes('Dacast'))) {
      imgSrc = dacastIcon;
    } else if (iconType === 'Telegram' || exportId === 'Telegram') {
      imgSrc = telegramIcon;
    } else if (iconType === 'Instagram' || exportId === 'Instagram') {
      imgSrc = instagramIcon;
    } else if (iconType === 'facebook' || exportId === 'Facebook') {
      imgSrc = facebookIcon;
    } else if (iconType === 'youtube' || exportId === 'Youtube') {
      imgSrc = youtubeIcon;
    } else if (iconType === 'Twitch' || exportId === 'Twitch') {
      imgSrc = twitchIcon;
    } else if (iconType === 'Kick' || exportId === 'Kick') {
      imgSrc = kickIcon;
    } else if (iconType === 'omniPlayer') {
      imgSrc = omniPlayerIcon;
    }

    return (
      <img
        alt="export icon"
        src={imgSrc}
        className="export-option-icon-img"
        style={{ width: '22px', height: '22px', objectFit: 'contain', background: 'transparent' }}
      />
    );
  };

  handleDragStart = (e, id) => {
    try {
      e.dataTransfer.setData('text/plain', id);
      e.dataTransfer.effectAllowed = 'move';
    } catch (err) {}
    this.setState({ draggedId: id });
  };

  handleDragOver = (e, id) => {
    e.preventDefault();
    try {
      e.dataTransfer.dropEffect = 'move';
    } catch (err) {}
    if (this.state.dragOverId !== id) {
      this.setState({ dragOverId: id });
    }
  };

  handleDragLeave = (e, id) => {
    if (this.state.dragOverId === id) {
      this.setState({ dragOverId: null });
    }
  };

  handleDrop = (e, targetId) => {
    e.preventDefault();
    let draggedId = null;
    try {
      draggedId = e.dataTransfer.getData('text/plain');
    } catch (err) {}
    draggedId = draggedId || this.state.draggedId;

    if (!draggedId || draggedId === targetId) {
      this.setState({ draggedId: null, dragOverId: null });
      return;
    }

    const currentOrdered = this.getOrderedExportMethods();
    const draggedIndex = currentOrdered.findIndex((m) => m.id === draggedId);
    const targetIndex = currentOrdered.findIndex((m) => m.id === targetId);

    if (draggedIndex !== -1 && targetIndex !== -1) {
      const newOrdered = [...currentOrdered];
      const [removed] = newOrdered.splice(draggedIndex, 1);
      newOrdered.splice(targetIndex, 0, removed);

      const newOrderIds = newOrdered.map((m) => m.id);
      try {
        localStorage.setItem('export_methods_custom_order', JSON.stringify(newOrderIds));
      } catch (err) {}
      this.setState({ customOrder: newOrderIds, draggedId: null, dragOverId: null });
    } else {
      this.setState({ draggedId: null, dragOverId: null });
    }
  };

  handleDragEnd = () => {
    this.setState({ draggedId: null, dragOverId: null });
  };

  getOrderedExportMethods = () => {
    const { customOrder } = this.state;
    if (!customOrder || !Array.isArray(customOrder)) {
      return EXPORT_METHODS;
    }
    const orderMap = {};
    customOrder.forEach((id, index) => {
      orderMap[id] = index;
    });

    return [...EXPORT_METHODS].sort((a, b) => {
      const indexA = orderMap[a.id] !== undefined ? orderMap[a.id] : 999;
      const indexB = orderMap[b.id] !== undefined ? orderMap[b.id] : 999;
      return indexA - indexB;
    });
  };

  getExportFullUrl = (item) => {
    const exportType = this.defineExportType(item.type, item);
    if (exportType.id === 'DacastSRT' || exportType.id === 'SRTCaller' || exportType.id === 'SRTListener') {
      return this.handleBuildUrl(item) || item.address || '';
    }
    const protocol = item.protocol || 'rtmp';
    const host = item.host || '';
    const port = item.port ? `:${item.port}` : '';
    const endpoint = item.endpoint ? `/${item.endpoint}` : '';
    const key = item.key ? `/${item.key}` : '';
    return `${protocol}://${host}${port}${endpoint}${key}`;
  };

  renderCreatedExportListItem = (item) => {
    const exportType = this.defineExportType(item.type, item);
    const fullUrl = this.getExportFullUrl(item);

    const exportLabels = this.state.exportLabels;
    const isOpenEdit =
      this.state.isOpenLabel.id === item.id
        ? this.state.isOpenLabel.isOpenEdit
        : false;
    const isExistLabel =
      exportLabels === null
        ? false
        : exportLabels.find((elem) => elem.id === item.id);
    const label = isExistLabel ? isExistLabel.exportLabel : false;

    const isOpenNew =
      this.state.isOpenLabel.id === item.id
        ? this.state.isOpenLabel.isOpen
        : false;
    const hasLabel = Boolean(label || isOpenEdit || isOpenNew);

    const labelTitle = label
      ? isOpenEdit
        ? 'Add export label'
        : 'Export label exist'
      : 'Add export label';

    const isOmniPlayer =
      exportType.id === 'OmnistreamLivePlayerRTMP' ||
      exportType.id === 'OmnistreamLivePlayerSRT';

    const canDeleteToggle =
      !isOmniPlayer ||
      (!keepAmsExports ||
        (!this.props.isUserFreeTrial && !this.props.isUserBasic && !this.props.isUserLiveOmni));

    return (
      <SwipeRevealListItem
        key={item.id}
        item={item}
        exportType={exportType}
        fullUrl={fullUrl}
        hasLabel={hasLabel}
        labelTitle={labelTitle}
        label={label}
        isOpenEdit={isOpenEdit}
        isOpenNew={isOpenNew}
        isOmniPlayer={isOmniPlayer}
        canDeleteToggle={canDeleteToggle}
        isOpenSwipe={this.state.openSwipeItemId === item.id}
        onToggleSwipe={(isOpen) =>
          this.setState({ openSwipeItemId: isOpen ? item.id : null })
        }
        onCloseAnyOpen={this.handleCloseAnySwipe}
        renderLabelItem={this.renderLabelItem}
        renderExportIcon={this.renderExportIcon}
        onCopyUrl={(item) =>
          item.type === 2 || item.type === 1
            ? this.handleShowModal({ currentTarget: { id: 'copy', value: item.id.toString(), getAttribute: () => null } })
            : this.onUrlClick(item)
        }
        onToggleEnable={(item) =>
          this.handleToggle({
            target: { value: item.id.toString(), checked: !item.isEnabled },
          })
        }
        onEdit={(item) =>
          this.handleShowModal({ currentTarget: { id: 'edit', value: item.id.toString(), getAttribute: () => null } })
        }
        onDelete={(item) =>
          this.handleShowModal({ currentTarget: { id: 'delete', value: item.id.toString(), getAttribute: () => null } })
        }
        onOpenLabel={(id) => this.setOpenLabel(id)}
        onShareVideo={(item) =>
          this.handleShowModal({ currentTarget: { id: 'share_video', value: item.id.toString(), getAttribute: () => null } })
        }
        onCopyEmbedCode={(item) =>
          this.handleCopyEmdedCode({
            currentTarget: { id: 'copy_embed_code', value: item.id.toString(), getAttribute: () => null },
            target: { id: 'copy_embed_code', value: item.id.toString() },
          })
        }
        onPlayVideo={(item) =>
          this.handleShowModal({ currentTarget: { id: 'play_video', value: item.id.toString(), getAttribute: () => null } })
        }
      />
    );
  };

  renderFieldItem = (field, formFields) => {
    const fieldValue = this.checkFieldKey(field.id, formFields);
    const isKey = field.id === 'key';

    return (
      <div key={field.id} className="premium-field-container">
        <label className="premium-field-label">{field.name}</label>
        <div className="premium-field-wrapper">
          <input
            className="premium-field-input"
            value={isKey && !this.state.isShowText && fieldValue ? '••••••••••••' : fieldValue}
            readOnly
            type="text"
          />
          <div className="premium-field-actions">
            {isKey && (
              <button
                className="field-action-btn material-icons"
                onClick={this.handleShowText}
                title={this.state.isShowText ? 'Hide' : 'Show'}
              >
                {this.state.isShowText ? 'visibility' : 'visibility_off'}
              </button>
            )}
            <button
              className="field-action-btn material-icons"
              onClick={() => this.handleCopyField(fieldValue, field.name)}
              title="Copy"
            >
              content_copy
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderUrlItem = (item) => {
    const exportType = this.defineExportType(item.type, item);
    const foundExportMethod = EXPORT_METHODS.find((method) => method.id === exportType.id);

    if (!foundExportMethod) {
      console.error(`Export method with id ${exportType.id} not found`);
      return null;
    }

    const typeExportFields = foundExportMethod.fields;
    const formFields = [];

    if (
      exportType.id === 'RTMP' ||
      exportType.id === 'DacastRTMP' ||
      exportType.id === 'Facebook' ||
      exportType.id === 'Youtube' ||
      exportType.id === 'Twitch' ||
      exportType.id === 'Telegram' ||
      exportType.id === 'Instagram' ||
      exportType.id === 'Kick' ||
      exportType.id === 'OmnistreamLivePlayerRTMP'
    ) {
      if (item.protocol === 'rtmp') {
        formFields['url'] = `rtmp://${item.host}${item.port ? `:${item.port}` : ''
          }${item.endpoint ? `/${item.endpoint}` : ''}`;
        formFields['key'] = `${item.key ? item.key : ''}`;
      }
      if (item.protocol === 'rtmps') {
        formFields['url'] = `rtmps://${item.host}${item.port ? `:${item.port}` : ''
          }${item.endpoint ? `/${item.endpoint}` : ''}`;
        formFields['key'] = `${item.key ? item.key : ''}`;
      }
    } else if (exportType.id === 'DacastSRT') {
      formFields['url'] = this.handleBuildUrl(item);
    } else {
      typeExportFields.forEach((elem) => {
        formFields[elem.id] = item[elem.id];
      });
    }

    const exportLabels = this.state.exportLabels;
    const isOpenEdit =
      this.state.isOpenLabel.id === item.id
        ? this.state.isOpenLabel.isOpenEdit
        : false;
    const isExistLabel =
      exportLabels === null
        ? false
        : exportLabels.find((elem) => elem.id === item.id);
    const label = isExistLabel ? isExistLabel.exportLabel : false;

    const labelTitle = label
      ? isOpenEdit
        ? 'Add export label'
        : 'Export label exist'
      : 'Add export label';
    return (
      <div id={item.id} key={item.id} className="export-list-card mb-2">
        <div className="card-header-row">
          <div className="card-header-main">
            <div className="export-type-icon">
              {this.renderExportIcon(exportType.id, exportType.iconType)}
            </div>
            <div className="card-header-text">
              <span className="export-type-name">{exportType.name}</span>
              {exportType.subTitle && (
                <span className="export-channel-subtitle">{exportType.subTitle}</span>
              )}
              {this.renderLabelItem(item.id)}
            </div>
          </div>
          <div className="card-actions">
            {(exportType.id === 'OmnistreamLivePlayerRTMP' ||
              exportType.id === 'OmnistreamLivePlayerSRT') && (
                <Fragment>
                  <button
                    className="action-icon-btn material-icons-outlined"
                    id="share_video"
                    title="Share Live Stream"
                    value={item.id.toString()}
                    onClick={this.handleShowModal}
                  >
                    share
                  </button>
                  <button
                    className="action-icon-btn"
                    id="copy_embed_code"
                    title="Copy embed code"
                    value={item.id.toString()}
                    onClick={this.handleCopyEmdedCode}
                  >
                    <img src="/images/share_icon.svg" alt="copy_embed_code" />
                  </button>
                  <button
                    className="action-icon-btn"
                    id="play_video"
                    title="Open video"
                    value={item.id.toString()}
                    onClick={this.handleShowModal}
                  >
                    <img src="/images/play_icon.svg" alt="play video" />
                  </button>
                </Fragment>
              )}
            <button
              className="action-icon-btn material-icons"
              id="copy"
              title="Copy full export url"
              value={item.id.toString()}
              onClick={
                item.type === 2 || item.type === 1
                  ? this.handleShowModal
                  : () => this.onUrlClick(item)
              }
            >
              content_copy
            </button>
            <button
              className="action-icon-btn material-icons"
              id="label"
              title={labelTitle}
              value={item.id.toString()}
              onClick={() => this.setOpenLabel(item.id)}
            >
              {label ? (isOpenEdit ? 'label' : 'label_off') : 'label'}
            </button>
            {exportType.id !== 'OmnistreamLivePlayerRTMP' &&
              exportType.id !== 'OmnistreamLivePlayerSRT' && (
                <button
                  className="action-icon-btn material-icons"
                  id="edit"
                  title="Edit export"
                  value={item.id.toString()}
                  onClick={this.handleShowModal}
                >
                  {exportType.id === 'SRTListener' ? 'autorenew' : 'edit'}
                </button>
              )}
            {(exportType.id !== 'OmnistreamLivePlayerRTMP' &&
              exportType.id !== 'OmnistreamLivePlayerSRT') ||
              (!keepAmsExports ||
                (!this.props.isUserFreeTrial && !this.props.isUserBasic && !this.props.isUserLiveOmni)) ? (
              <Fragment>
                <button
                  className="action-icon-btn material-icons delete-action"
                  id="delete"
                  title="Delete export"
                  value={item.id.toString()}
                  onClick={this.handleShowModal}
                >
                  delete_outline
                </button>
                <div className="card-toggle-wrapper">
                  <Toggle
                    checked={item.isEnabled}
                    value={item.id.toString()}
                    onChange={this.handleToggle}
                  />
                </div>
              </Fragment>
            ) : null}
          </div>
        </div>

        <div className="card-body-content premium-fields-area">
          {(() => {
            const hasPortAndStreamId =
              typeExportFields.some((f) => f.id === 'port') &&
              typeExportFields.some((f) => f.id === 'exportStreamId');
            if (hasPortAndStreamId) {
              const hostField = typeExportFields.find((f) => f.id === 'host');
              const portField = typeExportFields.find((f) => f.id === 'port');
              const streamIdField = typeExportFields.find((f) => f.id === 'exportStreamId');
              const keyField = typeExportFields.find((f) => f.id === 'key');
              const renderedFields = [];

              if (hostField) renderedFields.push(this.renderFieldItem(hostField, formFields));
              if (portField && streamIdField) {
                renderedFields.push(
                  <div key="port-streamid-row" className="premium-fields-2col-row">
                    {this.renderFieldItem(portField, formFields)}
                    {this.renderFieldItem(streamIdField, formFields)}
                  </div>
                );
              }
              if (keyField) renderedFields.push(this.renderFieldItem(keyField, formFields));

              typeExportFields.forEach((f) => {
                if (!['host', 'port', 'exportStreamId', 'key'].includes(f.id)) {
                  renderedFields.push(this.renderFieldItem(f, formFields));
                }
              });
              return renderedFields;
            }
            return typeExportFields.map((field) => this.renderFieldItem(field, formFields));
          })()}
        </div>
      </div>
    );
  };

  render() {
    // const title = 'Export Type';
    const { showOptions, focusedPrimaryId } = this.state;
    // const currentChoise = EXPORT_METHODS.find(
    // 	method => method.id === this.state.currentOption
    // );

    const rawExportList = this.state.exportList || [];

    const socialCount = rawExportList.filter((item) => {
      const id = this.defineExportType(item.type).id;
      return (
        id === 'DacastRTMP' ||
        id === 'DacastSRT' ||
        id === 'Telegram' ||
        id === 'Instagram' ||
        id === 'Youtube' ||
        id === 'Facebook' ||
        id === 'Twitch' ||
        id === 'Kick'
      );
    }).length;

    const rtmpCount = rawExportList.filter((item) => {
      const id = this.defineExportType(item.type).id;
      return (
        id === 'RTMP' ||
        id === 'DacastRTMP' ||
        id === 'OmnistreamLivePlayerRTMP'
      );
    }).length;

    const srtCount = rawExportList.filter((item) => {
      const id = this.defineExportType(item.type).id;
      return (
        id === 'SRTCaller' ||
        id === 'SRTListener' ||
        id === 'DacastSRT' ||
        id === 'OmnistreamLivePlayerSRT'
      );
    }).length;

    let activeCreatedCategory = this.state.activeCreatedCategory || 'all';
    if (activeCreatedCategory === 'social' && socialCount === 0) activeCreatedCategory = 'all';
    if (activeCreatedCategory === 'rtmp' && rtmpCount === 0) activeCreatedCategory = 'all';
    if (activeCreatedCategory === 'srt' && srtCount === 0) activeCreatedCategory = 'all';

    const filteredCreatedItems = rawExportList.filter((item) => {
      const exportType = this.defineExportType(item.type);
      const id = exportType.id;
      if (activeCreatedCategory === 'social') {
        return (
          id === 'DacastRTMP' ||
          id === 'DacastSRT' ||
          id === 'Telegram' ||
          id === 'Instagram' ||
          id === 'Youtube' ||
          id === 'Facebook' ||
          id === 'Twitch' ||
          id === 'Kick'
        );
      }
      if (activeCreatedCategory === 'rtmp') {
        return (
          id === 'RTMP' ||
          id === 'DacastRTMP' ||
          id === 'OmnistreamLivePlayerRTMP'
        );
      }
      if (activeCreatedCategory === 'srt') {
        return (
          id === 'SRTCaller' ||
          id === 'SRTListener' ||
          id === 'DacastSRT' ||
          id === 'OmnistreamLivePlayerSRT'
        );
      }
      return true;
    });

    const formObjectExport = () => {
      const reducer = (previousValue, currentValue) =>
        previousValue || currentValue;
      const exportTypes = {
        type: [
          ...new Set(
            this.state.exportList.map(
              (item) => this.defineExportType(item.type, item).id
            )
          ),
        ],
        isEnabled: [],
      };
      exportTypes.type.forEach((type) => {
        const existExport = this.state.exportList
          .filter((elem) => this.defineExportType(elem.type, elem).id === type)
          .map((item) => item.isEnabled);
        const isExistExport = existExport.reduce(reducer);
        exportTypes.isEnabled[type] = isExistExport;
      });
      return exportTypes;
    };

    const defineToggleOption = (id) => {
      const exportOption = formObjectExport().type.find((elem) => elem === id);
      if (exportOption) {
        if (formObjectExport().isEnabled[exportOption] === true) {
          return (
            <div className="status-dot status-dot-active" title="Active export" name={id} />
          );
        } else {
          return (
            <div className="status-dot status-dot-inactive" title="Inactive export" name={id} />
          );
        }
      } else {
        return null;
      }
    };

    const renderStatusBadge = (id) => {
      const exportOption = formObjectExport().type.find((elem) => elem === id);
      if (exportOption) {
        if (formObjectExport().isEnabled[exportOption] === true) {
          return (
            <span className="status-badge status-badge-active" title="Active export">
              ACTIVE
            </span>
          );
        } else {
          return (
            <span className="status-badge status-badge-inactive" title="Inactive export">
              INACTIVE
            </span>
          );
        }
      }
      return null;
    };

    const formatString = (name, id, expression) => {
      const boldWord = name.replace(expression, '');
      const lastIndex = name.lastIndexOf(' ');
      name = name.substring(0, lastIndex);
      return (
        <>
          {name}
          <span name={id} className="show-export-list-text-bold">
            &nbsp;{boldWord}
          </span>
        </>
      );
    };

    const formatFontOptionsButton = (name, id) => {
      if (
        id === 'OmnistreamLivePlayerRTMP' ||
        id === 'OmnistreamLivePlayerSRT'
      ) {
        return formatString(name, id, /LIVE OMNI - /g);
      } else if (id === 'RTMP') {
        return formatString(name, id, /Custom /g);
      } else return name;
    };

    return (
      <div className="export-container mt-1">
        {focusedPrimaryId ? (
          <div style={{ height: '100%' }}>
            {showOptions ? null : (
              <div className="export-list-item-wrapper">
                <div className="export-pills-header created-exports-header">
                  <div className="export-filter-pills">
                    <div className="export-filter-pills-left">
                      <button
                        type="button"
                        className={`export-filter-pill ${activeCreatedCategory === 'all' ? 'active' : ''}`}
                        onClick={() => this.setState({ activeCreatedCategory: 'all' })}
                      >
                        ALL
                      </button>
                      <button
                        type="button"
                        disabled={socialCount === 0}
                        className={`export-filter-pill ${socialCount === 0 ? 'disabled' : ''} ${activeCreatedCategory === 'social' ? 'active' : ''}`}
                        onClick={() => socialCount > 0 && this.setState({ activeCreatedCategory: 'social' })}
                      >
                        SOCIAL & PLATFORMS
                      </button>
                      <button
                        type="button"
                        disabled={rtmpCount === 0}
                        className={`export-filter-pill ${rtmpCount === 0 ? 'disabled' : ''} ${activeCreatedCategory === 'rtmp' ? 'active' : ''}`}
                        onClick={() => rtmpCount > 0 && this.setState({ activeCreatedCategory: 'rtmp' })}
                      >
                        RTMP/S
                      </button>
                      <button
                        type="button"
                        disabled={srtCount === 0}
                        className={`export-filter-pill ${srtCount === 0 ? 'disabled' : ''} ${activeCreatedCategory === 'srt' ? 'active' : ''}`}
                        onClick={() => srtCount > 0 && this.setState({ activeCreatedCategory: 'srt' })}
                      >
                        SRT
                      </button>
                    </div>
                    <div className="export-view-mode-toggle-group">
                      <button
                        type="button"
                        className={`export-view-mode-btn ${this.state.createdExportViewMode === 'carousel' ? 'active' : ''}`}
                        onClick={() => this.setCreatedExportViewMode('carousel')}
                        title="Carousel View (Default)"
                      >
                        <i className="material-icons">view_carousel</i>
                      </button>
                      <button
                        type="button"
                        className={`export-view-mode-btn ${this.state.createdExportViewMode === 'list' ? 'active' : ''}`}
                        onClick={() => this.setCreatedExportViewMode('list')}
                        title="List View (1 item per row)"
                      >
                        <i className="material-icons">view_list</i>
                      </button>
                    </div>
                  </div>
                </div>

                {(() => {
                  const reversedItems = [...filteredCreatedItems].reverse();
                  return this.state.createdExportViewMode === 'carousel' ? (
                    <div className="export-list-item-container pl-3 pr-3">
                      {reversedItems.length > 0 ? (
                        <Carousel
                          exportList={reversedItems}
                          exportComponent={reversedItems.map((item) => this.renderUrlItem(item))}
                          handleResetShowText={this.handleResetShowText}
                        />
                      ) : (
                        <div className="p-3 text-center text-muted">No exports found for this category</div>
                      )}
                    </div>
                  ) : (
                    <div className="created-exports-list-container">
                      {reversedItems.length > 0 ? (
                        reversedItems.map((item) => this.renderCreatedExportListItem(item))
                      ) : (
                        <div className="p-3 text-center text-muted">No exports found for this category</div>
                      )}
                    </div>
                  );
                })()}

                <div className="list-bottom-container">
                  <button
                    disabled={!this.state.isEnabledDeleteAll}
                    className={`export-footer-btn export-delete-btn-icon ${keepAmsExports &&
                      (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni) &&
                      rawExportList.length === 1
                      ? 'remove_cursor'
                      : ''
                      }`}
                    id="delete-all-exports"
                    title="Delete All Exports"
                    onClick={this.handleShowModal}
                  >
                    <span className="material-icons">delete_sweep</span>
                  </button>

                  <div className="export-actions-group">
                    <button
                      className="export-footer-btn export-refresh-btn"
                      onClick={() => this.handleRefreshExport(focusedPrimaryId)}
                    >
                      <span className="material-icons">refresh</span>
                      <span>REFRESH</span>
                    </button>

                    <button
                      className="export-footer-btn export-add-btn"
                      onClick={this.handleClick}
                    >
                      <span className="material-icons">add_circle</span>
                      <span>ADD</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showOptions ? (
              <div className="export-options-container">
                {(() => {
                  const allOrderedMethods = this.getOrderedExportMethods();
                  const hasOmniPlayer = allOrderedMethods.some(
                    (m) => m.isCreated && (m.id === 'OmnistreamLivePlayerRTMP' || m.id === 'OmnistreamLivePlayerSRT')
                  );
                  const activeCategory = this.state.activeCategory || 'all';

                  const filteredMethods = allOrderedMethods.filter((method) => {
                    if (!method.isCreated) return false;
                    if (activeCategory === 'social') {
                      return (
                        method.id === 'DacastRTMP' ||
                        method.id === 'DacastSRT' ||
                        method.id === 'Telegram' ||
                        method.id === 'Instagram' ||
                        method.id === 'Youtube' ||
                        method.id === 'Facebook' ||
                        method.id === 'Twitch' ||
                        method.id === 'Kick'
                      );
                    }
                    if (activeCategory === 'rtmp') {
                      return (
                        method.id === 'RTMP' ||
                        method.id === 'DacastRTMP' ||
                        method.id === 'OmnistreamLivePlayerRTMP'
                      );
                    }
                    if (activeCategory === 'srt') {
                      return (
                        method.id === 'SRTCaller' ||
                        method.id === 'SRTListener' ||
                        method.id === 'DacastSRT' ||
                        method.id === 'OmnistreamLivePlayerSRT'
                      );
                    }
                    if (activeCategory === 'omni') {
                      return method.id === 'OmnistreamLivePlayerRTMP' || method.id === 'OmnistreamLivePlayerSRT';
                    }
                    return true;
                  });

                  return (
                    <React.Fragment>
                      <div className="export-pills-header">
                        <div className="export-filter-pills">
                          <div className="export-filter-pills-left">
                            <button
                              type="button"
                              className={`export-filter-pill ${activeCategory === 'all' ? 'active' : ''}`}
                              onClick={() => this.setState({ activeCategory: 'all' })}
                            >
                              ALL
                            </button>
                            <button
                              type="button"
                              className={`export-filter-pill ${activeCategory === 'social' ? 'active' : ''}`}
                              onClick={() => this.setState({ activeCategory: 'social' })}
                            >
                              SOCIAL & PLATFORMS
                            </button>
                            <button
                              type="button"
                              className={`export-filter-pill ${activeCategory === 'rtmp' ? 'active' : ''}`}
                              onClick={() => this.setState({ activeCategory: 'rtmp' })}
                            >
                              RTMP/S
                            </button>
                            <button
                              type="button"
                              className={`export-filter-pill ${activeCategory === 'srt' ? 'active' : ''}`}
                              onClick={() => this.setState({ activeCategory: 'srt' })}
                            >
                              SRT
                            </button>
                            {hasOmniPlayer && (
                              <button
                                type="button"
                                className={`export-filter-pill ${activeCategory === 'omni' ? 'active' : ''}`}
                                onClick={() => this.setState({ activeCategory: 'omni' })}
                              >
                                OMNI
                              </button>
                            )}
                          </div>
                          <div className="export-view-mode-toggle-group">
                            <button
                              type="button"
                              className={`export-view-mode-btn ${this.state.exportViewMode === 'grid' ? 'active' : ''}`}
                              onClick={() => this.setExportViewMode('grid')}
                              title="Grid View (Default)"
                            >
                              <i className="material-icons">grid_view</i>
                            </button>
                            <button
                              type="button"
                              className={`export-view-mode-btn ${this.state.exportViewMode === 'list' ? 'active' : ''}`}
                              onClick={() => this.setExportViewMode('list')}
                              title="List View (1 item per row)"
                            >
                              <i className="material-icons">view_list</i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="export-options-content-container">
                        <div className={`export-options-grid ${this.state.exportViewMode === 'list' ? 'export-options-list-mode' : ''}`}>
                          {filteredMethods.map((method) => (
                            <div
                              key={method.id}
                              className={`export-option-card ${this.state.draggedId === method.id ? 'dragging' : ''} ${this.state.dragOverId === method.id ? 'drag-over' : ''}`}
                              id="create-export"
                              name={method.id}
                              value={method.id}
                              draggable="true"
                              onDragStart={(e) => this.handleDragStart(e, method.id)}
                              onDragOver={(e) => this.handleDragOver(e, method.id)}
                              onDragLeave={(e) => this.handleDragLeave(e, method.id)}
                              onDrop={(e) => this.handleDrop(e, method.id)}
                              onDragEnd={this.handleDragEnd}
                              onClick={this.handleShowModal}
                            >
                              <div className="card-main-content">
                                <div className="export-icon-wrapper">
                                  {this.renderExportIcon(method.id, method.iconType)}
                                  {this.state.exportViewMode !== 'list' && defineToggleOption(method.id)}
                                </div>
                                <div className="card-text-info">
                                  <span className="method-label">
                                    {formatFontOptionsButton(method.name, method.id)}
                                  </span>
                                </div>
                              </div>
                              <div className="card-status-and-action">
                                {this.state.exportViewMode === 'list' && renderStatusBadge(method.id)}
                                <i className="material-icons card-add-icon">add_circle_outline</i>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })()}

                <div className="export-options-footer">
                  <button
                    className="premium-list-btn"
                    onClick={() => this.showExports(focusedPrimaryId)}
                  >
                    <i className="material-icons">list_alt</i>
                    <span>Export List</span>
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          <p className="m-3">No primary selected.</p>
        )}
      </div>
    );
  }
}

Export.propTypes = {
  focusedPrimaryId: PropTypes.number,
  showNotification: PropTypes.func.isRequired,
};

export default Export;
